import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';
export function Locations() {
  const locations = [{
    name: 'Howell Auto Glass Service Center',
    address: '222 W Grand River Ave, Howell, MI 48843',
    phone: '517-545-7772',
    note: 'Main showroom and auto glass service center',
    isMain: true
  }, {
    name: 'Ann Arbor Satellite Office',
    address: '2723 South State St, Suite 150, Ann Arbor, MI 48104',
    phone: '734-887-6556',
    isMain: false
  }, {
    name: 'Novi Satellite Office',
    address: '39555 Orchard Hill Place, Suite 600, Novi, MI 48375',
    phone: '248-924-9899',
    isMain: false
  }];
  return <section className="py-16 lg:py-24 bg-slate-50 border-t border-slate-200" data-id="element-279">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-280">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-281">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-6" data-id="element-282">
            Auto Glass Service Near Howell, Ann Arbor, Novi & Southeast Michigan
          </h2>
          <p className="text-lg text-slate-600" data-id="element-283">
            Kosin's Glass serves Howell, Ann Arbor, Novi and communities across
            Southeast Michigan, including Brighton, Fenton, Hartland,
            Fowlerville, Northville, Lansing, East Lansing, Grand Blanc,
            Webberville, Williamston, Livonia, Milford, Pinckney, Whitmore Lake,
            Wixom and nearby communities.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12" data-id="element-284">
          {locations.map((loc, index) => <div key={index} className={`bg-white rounded-2xl p-8 border ${loc.isMain ? 'border-brand-blue shadow-lg shadow-brand-blue/10' : 'border-slate-200 shadow-sm'} relative overflow-hidden scroll-fade-up`} style={{
          animationDelay: `${index * 0.08}s`
        }} data-id="element-285">
              {loc.isMain && <div className="absolute top-0 right-0 bg-brand-blue text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-286">
                  Main Center
                </div>}
              <h3 className="text-xl font-bold text-navy-900 mb-4 pr-16" data-id="element-287">
                {loc.name}
              </h3>
              <div className="space-y-4" data-id="element-288">
                <div className="flex items-start gap-3" data-id="element-289">
                  <MapPin className="w-5 h-5 text-slate-400 shrink-0 mt-0.5" data-id="element-290" />
                  <span className="text-slate-600" data-id="element-291">{loc.address}</span>
                </div>
                <div className="flex items-start gap-3" data-id="element-292">
                  <Phone className="w-5 h-5 text-brand-blue shrink-0 mt-0.5" data-id="element-293" />
                  <a href={`tel:${loc.phone.replace(/-/g, '')}`} className="text-navy-900 font-bold hover:text-brand-blue transition-colors" data-id="element-294">
                    {loc.phone}
                  </a>
                </div>
                {loc.note && <div className="pt-4 mt-4 border-t border-slate-100" data-id="element-295">
                    <p className="text-sm text-slate-500 italic" data-id="element-296">{loc.note}</p>
                  </div>}
              </div>
            </div>)}
        </div>

        <div className="bg-white rounded-2xl p-8 border border-slate-200 shadow-sm max-w-2xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-12" data-id="element-297">
          <div className="flex items-center gap-3" data-id="element-298">
            <Clock className="w-8 h-8 text-brand-blue" data-id="element-299" />
            <h3 className="text-xl font-bold text-navy-900" data-id="element-300">
              Hours of Operation
            </h3>
          </div>
          <div className="text-slate-600 space-y-1" data-id="element-301">
            <p data-id="element-302">
              <span className="font-medium text-navy-900" data-id="element-303">Monday–Friday:</span>{' '}
              8:00 a.m. to 5:00 p.m.
            </p>
            <p data-id="element-304">
              <span className="font-medium text-navy-900" data-id="element-305">Saturday:</span> 9:00
              a.m. to 3:00 p.m.
            </p>
            <p data-id="element-306">
              <span className="font-medium text-navy-900" data-id="element-307">Sunday:</span> Closed
            </p>
          </div>
        </div>
      </div>
    </section>;
}